import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const NCAABConfig: BetQLSportItem = {
  id: "735cf219-4ffc-4ca0-8307-ed94853df175",
  name: "NCAAB",
  url: "ncaab",
  tabName: "NCAAB",
  icon: "football",
  imagePath: "NCAA",
  key: "CBK",
  lookupKey: "ncaab",
  favoriteLine: "spread",
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: true,
  has1HmoneylinePowerRating: true,
  has1HtotalPowerRating: true,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: false,
  hasNews: false,
  hasLineup: false,
  hasSchedule: true,
  hasConfiguredSchedule: false,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: true,
  hasConferenceDropdown: true,
  hasNewsInjuriesColumn: false,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: true,
  hasPlayerProps: false,
  hasRecommendedBets: true,
  hasPopularEvents: true,
  isCollege: true,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,5,9,15,4]}',
  defaultColumnOrder: [2, 5, 9, 15, 4],
  publicThreshold: 65,
  sharpPercentThreshold: 30,
  sharpCountThreshold: 200,
  publicCountThreshold: 200,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Spread",
      key: "spread",
      url: "spread",
    },
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline",
    },
    {
      name: "Total",
      key: "total",
      url: "totals-spread",
    },
    {
      name: "1st Half Spread",
      key: "1Hspread",
      url: "first-half-lines",
    },
    {
      name: "1st Half Moneyline",
      key: "1Hmoneyline",
      url: "first-half-moneyline",
    },
    {
      name: "1st Half Total",
      key: "1Htotal",
      url: "first-half-totals-spread",
    },
    {
      name: "2nd Half Spread",
      key: "2Hspread",
      url: "second-half-lines",
    },
    {
      name: "2nd Half Moneyline",
      key: "2Hmoneyline",
      url: "second-half-moneylines",
    },
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["spread", "moneyline", "total", "1Hspread", "1Hmoneyline", "1Htotal", "2Hspread", "2Hmoneyline"],
  conferenceList: [
    {
      name: "NCAA Tournament",
      key: "NCAAT",
      url: "ncaa-tournament",
    },
    {
      name: "NIT Tournament",
      key: "NIT",
      url: "nit-tournament",
    },
    {
      name: "CBI Tournament",
      key: "CBI",
      url: "cbi-tournament",
    },
    {
      name: "The Basketball Classic",
      key: "TBC",
      url: "the-basketball-classic",
    },
    {
      name: "All Conferences",
      key: "ALL",
      url: "all",
    },
    {
      name: "Top 25",
      key: "TOP25",
      url: "top-25",
    },
    {
      name: "America East",
      key: "AMEAST",
      url: "america-east",
    },
    {
      name: "American",
      key: "AAC",
      url: "american",
    },
    {
      name: "Atlantic 10",
      key: "A10",
      url: "atlantic-10",
    },
    {
      name: "Atlantic Coast",
      key: "ACC",
      url: "atlantic-coast",
    },
    {
      name: "Atlantic Sun",
      key: "ASUN",
      url: "atlantic-sun",
    },
    {
      name: "Big 12",
      key: "B12",
      url: "big-12",
    },
    {
      name: "Big East",
      key: "BEC",
      url: "big-east",
    },
    {
      name: "Big Sky",
      key: "BSC",
      url: "big-sky",
    },
    {
      name: "Big South",
      key: "BIGSOUTH",
      url: "big-south",
    },
    {
      name: "Big Ten",
      key: "B1G",
      url: "big-ten",
    },
    {
      name: "Big West",
      key: "BWC",
      url: "big-west",
    },
    {
      name: "Colonial",
      key: "CAA",
      url: "colonial",
    },
    {
      name: "Conference USA",
      key: "CUSA",
      url: "conference-usa",
    },
    {
      name: "Horizon League",
      key: "HORIZON",
      url: "horizon-league",
    },
    {
      name: "Ivy League",
      key: "IVY",
      url: "ivy-league",
    },
    {
      name: "Metro Atlantic Athletic",
      key: "MAAC",
      url: "metro-atlantic-athletic",
    },
    {
      name: "MAC",
      key: "MAC",
      url: "mac",
    },
    {
      name: "MEAC",
      key: "MEAC",
      url: "meac",
    },
    {
      name: "Missouri Valley",
      key: "MVC",
      url: "missouri-valley",
    },
    {
      name: "Mountain West",
      key: "MWC",
      url: "mountain-west",
    },
    {
      name: "Northeast",
      key: "NEC",
      url: "northeast",
    },
    {
      name: "Ohio Valley",
      key: "OVC",
      url: "ohio-valley",
    },
    {
      name: "Pac-12",
      key: "P12",
      url: "pac-12",
    },
    {
      name: "Patriot League",
      key: "PATRIOT",
      url: "patriot-league",
    },
    {
      name: "SEC",
      key: "SOUTHEASTERN",
      url: "sec",
    },
    {
      name: "Southern",
      key: "SOCON",
      url: "southern",
    },
    {
      name: "Southland",
      key: "SOUTHLAND",
      url: "southland",
    },
    {
      name: "Southwestern Athletic",
      key: "SWAC",
      url: "southwestern-athletic",
    },
    {
      name: "Summit",
      key: "SUMMIT",
      url: "summit",
    },
    {
      name: "Sun Belt",
      key: "SBC",
      url: "sun-belt",
    },
    {
      name: "West Coast",
      key: "WCC",
      url: "west-coast",
    },
    {
      name: "WAC",
      key: "WAC",
      url: "wac",
    },
  ],
};

export default NCAABConfig;
